import $ from 'jquery'

$(document).ready(() => {
  var message_display = false;
  var suggestion_email = "";

  function validateEmailFormat(email) { // this is used to prevent the sending of validation of invalid email formats
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  function create_cookie() {
    var expires = new Date();
    expires.setTime(expires.getTime() + (30 * 24 * 60 * 60 * 1000));
    document.cookie = 'wrong_email=checked;expires=' + expires.toUTCString();
  }

  // Hide .auto-correct-email-suggestion
  $(".auto-correct-email-suggestion").hide();

  // Insert .auto-correct-email-suggestion in the right place
  $(".auto-correct-email-suggestion").insertAfter(".auto-correct-email");

  // If focusout input.auto-correct-email
  $("input.auto-correct-email").focusout(function () {

    let email = $("#user_email").val();
    let firstname = $("#user_surname").val();
    let lastname = $("#user_name").val();

    if (validateEmailFormat(email)) {
      $.ajax({
        type: "POST",
        url: "/check_email",
        dataType: "json",
        data: { email_to_check: email, firstname, lastname },
        complete: function () {
        },
        success: function (data) {
          if (!data.error_found) {
            $(".auto-correct-email-suggestion").hide();
            // Remove class to input.auto-correct-email if no suggestion provided
            $(".auto-correct-email").removeClass("auto-correct-email-style");
            message_display = false
            return;
          }
          if (data.new_email) {
            if (data.new_email != email) {
              if (message_display == false) {
                suggestion_email = data.new_email;
                $("#maybe-correct-email").text(suggestion_email);
                $(".auto-correct-email-suggestion").show();
                // Add class to input.auto-correct-email if suggestion
                $(".auto-correct-email").addClass("auto-correct-email-style");
                message_display = true;
              } else {
                // Message already shown but we should update for the new suggestion
                suggestion_email = data.new_email;
                $("#maybe-correct-email").text(suggestion_email);
              }
            }
            else {
              message_display = false;
            }
          }
        },
      });
    }
  });

  // Click on #yes-i-m-correct
  $("#yes-i-m-correct").click(function () {
    $(".auto-correct-email-suggestion").hide();
    $(".auto-correct-email").val(suggestion_email);
    $(".auto-correct-email").removeClass("auto-correct-email-style");
    create_cookie();
  });

  // Click on #you-are-wrong
  $("#you-are-wrong").click(function () {
    $(".auto-correct-email-suggestion").hide();
    $(".auto-correct-email").removeClass("auto-correct-email-style");
    create_cookie();
  });

  // If input empty
  $('.auto-correct-email').blur(function () {
    if (!$.trim(this.value).length) {
      $(".auto-correct-email-suggestion").hide();
      $(".auto-correct-email").removeClass("auto-correct-email-style");
    }
  });  
})